import {NgModule} from "@angular/core";
import {HttpClientModule} from "@angular/common/http";
import {RouterModule, Routes} from "@angular/router";
// import {TouchTestPageModule} from "../pages/touch-test/touch-test.module";
import {UnauthorizedHomePageModule} from "../pages/unauthorized-home-page/unauthorized-home-page.module";
//import {ScreenTestPageModule} from "../pages/screen-test/screen-test.module";

export const appRouteList: Routes = [
    /*{
       // http://localhost:8100/#/device-touch-test?callback_url=rrr&ticket=2&token=zeezze&apikey=fgfg
        path: 'device-touch-test',
        loadChildren: () => TouchTestPageModule,
    },
    {
       // http://localhost:8100/#/device-photo-test?callback_url=rrr&ticket=2&token=zeezze&apikey=fgfg
        path:'device-photo-test',
        loadChildren : () => ScreenTestPageModule,
    },*/
    {
        path:'unauthorized-home-page',
        loadChildren : () => UnauthorizedHomePageModule,
    },
];

@NgModule({
    exports: [
        RouterModule
    ],
    imports: [
        HttpClientModule,
        RouterModule.forRoot(appRouteList, { enableTracing: false }) //debug enableTracing
    ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts